import { render, staticRenderFns } from "./ComboTipoNotificacao.vue?vue&type=template&id=ad52846a"
import script from "./ComboTipoNotificacao.vue?vue&type=script&lang=ts"
export * from "./ComboTipoNotificacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports